import { Button, styled } from '@mui/material';
import FlexBetween from 'components/flexbox/FlexBetween';
import SearchInput from 'components/input-fields/SearchInput';
import axiosInstance from 'utils/axios';
import { Download } from '@mui/icons-material';
import * as FileSaver from 'file-saver';
const SecondaryWrapper = styled(FlexBetween)(({ theme }) => ({
    gap: 8,
    flexWrap: 'wrap',
    margin: '24px 0',
    [theme.breakpoints.down(550)]: {
        '& .MuiInputBase-root': {
            maxWidth: 'calc(100% - 90px)',
        },
    },
})); // --------------------------------------------------------------------

// --------------------------------------------------------------------
const SearchArea = ({ value, onChange, setValue, onEnter }) => {
    const handleDownload = async () => {
        try {
            const response = await axiosInstance.get('/api/prv/re-registrations/download', {
                responseType: 'blob',
            });
            FileSaver.saveAs(response.data, 'Re-registration Data.xlsx');
        } catch (error) {
            console.log(error);
        }
    };
    return (
        <SecondaryWrapper>
            <SearchInput
                placeholder="Search..."
                value={value || ''}
                onChange={(e) => {
                    if (onChange && setValue) {
                        setValue(e.target.value);
                        onChange(e.target.value);
                    }
                    onChange(e.target.value);
                }}
                onEnter={onEnter}
            />
            {!['registrator'].includes(localStorage.getItem('role')) && (
                <Button
                    variant="contained"
                    color="primary"
                    style={{ cursor: 'pointer', fontSize: 14 }}
                    endIcon={<Download />}
                    onClick={handleDownload}
                >
                    Download Data
                </Button>
            )}
        </SecondaryWrapper>
    );
};

export default SearchArea;
